module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Unidade solicitante")]), _vm._v(" "), _c('label', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['alt', '1']),
      expression: "['alt', '1']"
    }],
    staticClass: "labe-telca-atalho",
    on: {
      "shortkey": function($event) {
        _vm.focoUnidades()
      }
    }
  }, [_vm._v("alt + 1")]), _vm._v(" "), _c('v-select', {
    ref: "selectUnidade",
    attrs: {
      "placeholder": "SELECIONE A UNIDADE SOLICITANTE...",
      "label": "nome",
      "options": _vm.unidades
    },
    on: {
      "change": function($event) {
        _vm.limparProcedimentos()
      }
    },
    model: {
      value: (_vm.contratoSolicitanteSelecionado),
      callback: function($$v) {
        _vm.contratoSolicitanteSelecionado = $$v
      },
      expression: "contratoSolicitanteSelecionado"
    }
  })], 1)])]), _vm._v(" "), (_vm.contratoSolicitanteSelecionado) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerPaciente
    },
    attrs: {
      "for": ""
    }
  }, [_vm._v("Nome do paciente")]), _vm._v(" "), _c('label', {
    staticClass: "labe-telca-atalho"
  }, [_vm._v("alt + 2")]), _vm._v(" "), _c('select-paciente', {
    ref: "btnPaciente",
    attrs: {
      "nome-paciente-recuperado": _vm.dados.paciente.nome,
      "cidadeUnidadeSolicitante": _vm.contratoSolicitanteSelecionado.unidade.cidade_id,
      "unidadeSolicitante": _vm.contratoSolicitanteSelecionado.unidade,
      "show-text-danger-paciente": _vm.showTextDangerPaciente
    },
    on: {
      "limpar": function($event) {
        (_vm.historico = {}), (_vm.historicoAntigo = {})
      },
      "setPacienteSelecionado": function (paciente) {
        _vm.setPacienteSelecionado(paciente);
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.showTextDangerPaciente
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("CNS do paciente")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (this.dados.paciente.cartao_sus),
      expression: "this.dados.paciente.cartao_sus"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": (this.dados.paciente.cartao_sus)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(this.dados.paciente, "cartao_sus", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.showTextDangerPaciente
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Município do paciente")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (this.dados.paciente.cidade.nome),
      expression: "this.dados.paciente.cidade.nome"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": (this.dados.paciente.cidade.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(this.dados.paciente.cidade, "nome", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    class: {
      'erro-validacao': _vm.showTextDangerProfissional
    },
    attrs: {
      "for": ""
    }
  }, [_vm._v("Profissional solicitante")]), _vm._v(" "), _c('label', {
    staticClass: "labe-telca-atalho"
  }, [_vm._v("alt + 3")]), _vm._v(" "), _c('select-profissional', {
    ref: "btnProfissional",
    attrs: {
      "nome-profissional-recuperado": _vm.dados.profissionalSolicitante.nome,
      "unidade-solicitante-selecionada": _vm.contratoSolicitanteSelecionado.unidade,
      "show-text-danger-profissional": _vm.showTextDangerProfissional
    },
    on: {
      "setProfissionalSelecionado": function (profissional) {
        _vm.setProfissionalSelecionado(profissional);
      }
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('historicos', {
    ref: "historicos",
    attrs: {
      "show-info": _vm.showInfo,
      "pacienteId": _vm.dados.paciente.id
    },
    on: {
      "showModalNaoRealizados": function($event) {
        _vm.showModalNaoRealizados = true
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box",
    class: {
      'box-danger': _vm.showTextDangerProcedimento
    }
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title",
    class: {
      'erro-validacao': _vm.showTextDangerProcedimento
    }
  }, [_vm._v("Procedimentos da solicitação")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['alt', '4']),
      expression: "['alt', '4']"
    }],
    staticClass: "btn btn-sm",
    class: {
      'btn-danger': _vm.showTextDangerProcedimento
    },
    attrs: {
      "type": "button"
    },
    on: {
      "shortkey": function($event) {
        _vm.mostrarModalProcedimento()
      },
      "click": function($event) {
        _vm.mostrarModalProcedimento()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Adicionar")]), _vm._v(" "), _c('label', {
    staticClass: "labe-telca-atalho"
  }, [_vm._v("alt + 4")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.dados.procedimentos), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item.procedimento.quantidade))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.procedimento.codigo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.procedimento.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("tipo_consulta")(item.procedimento.tipo_consulta)))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-sm btn-danger",
      on: {
        "click": function($event) {
          _vm.removerProcedimento(index)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-trash"
    })])])])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Diagnósticos indicados")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['alt', '5']),
      expression: "['alt', '5']"
    }],
    ref: "btnAdicionarDiagnostico",
    staticClass: "btn btn-sm btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "shortkey": function($event) {
        _vm.showModalAddDiagnosticos = true
      },
      "click": function($event) {
        _vm.showModalAddDiagnosticos = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Adicionar")]), _vm._v(" "), _c('label', {
    staticClass: "labe-telca-atalho"
  }, [_vm._v("alt + 5")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.dados.diagnosticos), function(diagnostico, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(diagnostico.cid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(diagnostico.nome))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-sm btn-danger",
      on: {
        "click": function($event) {
          _vm.removerDiagnostico(index)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-trash"
    })])])])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['alt', 'r']),
      expression: "['alt', 'r']"
    }],
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "title": "pressione alt + r para resolver"
    },
    on: {
      "click": _vm.resolver,
      "shortkey": _vm.resolver
    }
  }, [_c('span', {
    staticClass: "fa fa-arrow-right"
  }), _vm._v(" Resolver")])])])], 1)])])]), _vm._v(" "), _c('modal-add-procedimentos', {
    attrs: {
      "contrato-solicitante-selecionado": _vm.contratoSolicitanteSelecionado,
      "profissional-solicitante-selecionado": _vm.dados.profissionalSolicitante,
      "show": _vm.showModalAddProcedimentos
    },
    on: {
      "close": function($event) {
        (_vm.showModalAddProcedimentos = false), (_vm.focusAdicionarDiagnositico = true)
      },
      "incluirProcedimentoSelecionado": function (contratoProcedimento) {
        _vm.incluirProcedimentoSelecionado(contratoProcedimento);
      }
    }
  }), _vm._v(" "), _c('modal-quantidade-procedimentos', {
    attrs: {
      "show": _vm.showModalQuantidadeProcedimentos,
      "contrato-procedimento": _vm.contratoProcedimentoTemp
    },
    on: {
      "close": function($event) {
        _vm.showModalQuantidadeProcedimentos = false
      },
      "addProcedimentoSelecionado": function (contratoProcedimento) {
        _vm.addProcedimentoSelecionado(contratoProcedimento);
      }
    }
  }), _vm._v(" "), _c('modal-add-diagnosticos', {
    attrs: {
      "show": _vm.showModalAddDiagnosticos
    },
    on: {
      "close": function($event) {
        _vm.showModalAddDiagnosticos = false
      },
      "addDiagnosticoSelecionado": function (diagnostico) {
        _vm.addDiagnosticoSelecionado(diagnostico);
      }
    }
  }), _vm._v(" "), _c('modal-nao-realizados', {
    attrs: {
      "regulacao": false,
      "nao-realizados": _vm.naoRealizados,
      "show": _vm.showModalNaoRealizados
    },
    on: {
      "selecionarProfissional": function($event) {
        _vm.showModalNaoRealizados = false;
        _vm.$refs.btnProfissional.abrirModal();
      },
      "close": function($event) {
        _vm.showModalNaoRealizados = false
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-9"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Marcação de Atendimentos")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Quantidade")]), _vm._v(" "), _c('th', [_vm._v("Código")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Consulta")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "1%"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Código CID")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "1%"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-1ca930a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atendimentos/solicitacao/index.vue
// module id = 811
// module chunks = 0